// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".map[data-v-06704c64]{width:100%;height:10rem}.detail-chips[data-v-06704c64]{margin:-8px}.detail-chips .v-chip[data-v-06704c64]{margin:8px}.white-space--pre-line[data-v-06704c64]{white-space:pre-line}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
